import { ReactNode } from "react";
import { Link, List, ListItem, ListItemText } from "@mui/material";
import { DynamicContentHtmlList } from "../DynamicContentComponent";

export const DynamicHtmlList = ({ listItems, listType, sxProps, key, childElements }: DynamicContentHtmlList): ReactNode  => {
    if (!listItems || listItems.length === 0) {
      return null;
    }

    let sxPropsObject = {};
    if (sxProps) {
      sxPropsObject = sxProps;
    }

    const componentListType = listType === "unordered" ? "ul" : "ol"; 

    const updateQueryParam = (queryParamAndValue:string) => {
      // Pattern my be <query-param-name>:<new values>
      if (!queryParamAndValue.includes("=")) {
        return;
      }
      const split:string[] = queryParamAndValue.split("=");
      if (split.length != 2) {
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.set(split[0], split[1]);
      window.history.pushState(null, '', url.toString());
    }

    sxPropsObject["listStyleType"] = listType === "unordered" ? "disc" : "decimal";

    return <List component={componentListType} sx={sxPropsObject}>
      {listItems.map((item, index) => {

        // determine if item is just string or object
        if (typeof item === "object") {
          const textPrimary = item.primaryText;
          const textSecondary = item.secondaryText || '';
          let linkPrimary = item.primaryLink || '';
          const linkPrimaryQueryParamChange = linkPrimary.includes("queryParamChange") && linkPrimary.replace("queryParamChange:", "");
          // Set item type number according to supplied props
          let itemTypeNumber = 0; // default - textPrimary only
          if (textPrimary && textSecondary && linkPrimary) { 
            itemTypeNumber = 1; 
          } else if (textPrimary && textSecondary) {
            itemTypeNumber = 2; 
          } else if (textPrimary && linkPrimary) {
            itemTypeNumber = 3;
          }  
          if (linkPrimaryQueryParamChange) {
            linkPrimary = "#"
          }

          switch(itemTypeNumber) {
            case 0: {
              return (
                <ListItem key={`${key}-list-item-${index}`} sx={{ fontSize: "1.25rem", fontWeight: "500", paddingLeft: "50px" }}>
                  <ListItemText
                    primary={textPrimary}
                    slotProps={{ primary: {fontSize: "1.25rem", fontWeight: "500"} }}  
                    sx={{ display: "list-item" }} />
                </ListItem>
              )
            }
            case 1: {
              return (
                <ListItem key={`${key}-list-item-${index}`} sx={{ fontSize: "1.25rem", fontWeight: "500", paddingLeft: "50px" }}>
                  <Link underline="hover" color="inherit" key={`htmllist-item-${index}`} href={linkPrimary}>
                    <ListItemText
                      primary={textPrimary}
                      secondary={textSecondary}
                      slotProps={{ primary: {fontSize: "1.25rem", fontWeight: "500"} }}  
                      sx={{ display: "list-item" }} />
                  </Link>    
                </ListItem>
              )
            }
            case 2: {
              return (
                <ListItem key={`${key}-list-item-${index}`} sx={{ fontSize: "1.25rem", fontWeight: "500", paddingLeft: "50px" }}>
                  <ListItemText
                    primary={textPrimary}
                    secondary={textSecondary}
                    slotProps={{ primary: {fontSize: "1.25rem", fontWeight: "500"} }}  
                    sx={{ display: "list-item" }} />
                </ListItem>
              )
            }
            case 3: {
              return (
                <ListItem key={`${key}-list-item-${index}`} sx={{ fontSize: "1.25rem", fontWeight: "500", paddingLeft: "50px" }}>
                  <Link underline="hover" color="inherit" key={`htmllist-item-${index}`} href={linkPrimary} onClick={() => updateQueryParam(linkPrimaryQueryParamChange)}>
                    <ListItemText
                      primary={textPrimary}
                      slotProps={{ primary: {fontSize: "1.25rem", fontWeight: "500"} }}  
                      sx={{ display: "list-item" }}
                    />
                  </Link>    
                </ListItem>
              )
            }

          }

        } // If advanced type other return simple type 

        return (
          <ListItem key={`${key}-list-item-${index}`} sx={{ fontSize: "1.25rem", fontWeight: "500", paddingLeft: "50px" }}>
            <ListItemText
              primary={item}
              slotProps={{ primary: {fontSize: "1.25rem", fontWeight: "500"} }}  
              sx={{ display: "list-item" }} />
          </ListItem>
        )
      })}
      {childElements || ''}
    </List>
}